import { render } from "./bid-countdown.vue?vue&type=template&id=0045cc13&scoped=true"
import script from "./bid-countdown.vue?vue&type=script&lang=ts"
export * from "./bid-countdown.vue?vue&type=script&lang=ts"

import "./bid-countdown.vue?vue&type=style&index=0&id=0045cc13&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0045cc13"

export default script